// Datos de empresa — sustituir por los definitivos antes del lanzamiento.
export const COMPANY = {
  brand: "Bevela",
  legalName: "Bevela Náutica, S.L.",
  cif: "B-00000000",
  address: "Calle Ejemplo 1, 03730 Jávea (Alicante), España",
  email: "hola@bevela.es",
  phone: "+34 600 000 000",
  whatsapp: "34600000000",
  domain: "bevela.es",
};
